import { BindableFormCheck } from "../components/BindableFormCheck";
import { SimpleFormField } from "../components/SimpleFormField";
import { Trash, ArrowDown, ArrowUp } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import { arrayElementMove, useForceRender, getRandomId } from "../util/utils";

export function QuestionEditorForm(props) {
	let obj = props.bindObject;
	let qattr = props.questionsAttribute;
	let forceRender = useForceRender();

	let addQuestionAction = () => {
		let qid = getRandomId();
		obj[qattr].push({
			"id": getRandomId(),
			"questionId": qid,
			"question": {
				"id": qid,
			}			
		});
		forceRender();
	};

	let removeQuestionAction = (oq) => () => {
		obj[qattr] = obj[qattr].filter(myoq => (oq != myoq));
		forceRender();
	};

	let questionMoveAction = (oq, offset) => () => {
		obj[qattr] = arrayElementMove(obj[qattr], oq, offset);
		forceRender();
	};

	return <div>
		<div className="table-responsive"><table className="table">
			<thead>
				<tr>
					<th>Short Name</th>
					<th>Question</th>
					<th>Comments Only?</th>
					<th>Resolvable?</th>
					<th>Skippable?</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{obj[qattr].map(oq => {
					let q = oq.question;
					return <tr key={oq.id}>
						<td><SimpleFormField bindObject={q} bindAttribute="name" /></td>
						<td><SimpleFormField bindObject={q} bindAttribute="question" /></td>
						<td><BindableFormCheck title="Comment Only" bindObject={q} bindAttribute="commentsOnly" /></td>
						<td><BindableFormCheck title="Resolvable" bindObject={q} bindAttribute="resolvable" /></td>
						<td><BindableFormCheck title="Skippable" bindObject={q} bindAttribute="skippable" /></td>
						<td>
							<ArrowDown className="mx-2" onClick={questionMoveAction(oq, 1)} />
							<ArrowUp className="mx-2" onClick={questionMoveAction(oq, -1)} />
							<Trash className="mx-4" onClick={removeQuestionAction(oq)} />
						</td>
					</tr>;
				})}
			</tbody>
		</table></div>
		{obj[qattr].length == 0 && <p>{props.emptyText}</p>}

		<Button onClick={addQuestionAction} className="mb-4">Add Question</Button>
	</div>;
}